import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  'menu.login': 'Login Page',
  'pages.layouts.userLayout.title': 'SJRecords Royalty Query Platform',
  'pages.login.accountLogin.tab': 'Account Password Login',
  'pages.login.mailLogin.tab': 'Email Login',
  'pages.login.username.required': 'Please enter your Email',
  'pages.login.password.placeholder': 'Please enter your password',
  'pages.login.password.required': 'Please enter your password',
  'pages.login.email.placeholder': 'Email',
  'pages.login.email.required': 'Please enter your email',
  'pages.login.email.invalid': 'Invalid email format!',
  'pages.login.captcha.placeholder': 'Please enter the verification code',
  'pages.login.phoneLogin.getVerificationCode': 'Get Verification Code',
  'pages.login.captcha.required': 'Please enter the verification code!',
  'pages.login.failure': 'Incorrect username or password',
  'pages.login.success': 'Login successful!',
  'pages.login.failure.retry': 'Login failed, please try again!',
  'pages.welcome.title': "Welcome to Farfardisc",
  'pages.welcome.subtitle': "Please use the left menu",

  'pages.contract.contractName': 'Settlement Compilation Name',
  'pages.contract.contractId': 'Settlement Compilation ID',
  'pages.contract.artistName': 'Artist Name',
  'pages.contract.shareRate': 'Share Rate',
  'pages.contract.contractStartTime': 'Start Date',
  'pages.contract.contractEndTime': 'End Date',
  'pages.contract.status': 'Status',
  'pages.contract.active': 'Active',
  'pages.contract.expired': 'Expired',
  'pages.contract.disabled': 'Disabled',
  'pages.contract.hide': 'Hide',
  'pages.contract.form.save.draft': "Save Draft",
  'pages.contract.pendingPayment': 'Settlement Compilation Pending Payment￥',
  'pages.contract.pendingPayment.tooltip': 'If positive, it represents the amount to be paid to the artist. If negative, it represents the prepaid amount. Reports must be confirmed by the artist to be included in the settlement compilation pending payment.',
  'pages.contract.actions': 'Actions',
  'pages.contract.edit': 'Edit',
  'pages.contract.view': 'View',
  'pages.contract.refresh': 'Refresh',
  'pages.contract.contractName.placeholder': 'Settlement Compilation Name',
  'pages.contract.artistName.placeholder': 'Artist Name',
  'pages.contract.selectStatus': 'Select Status',
  'pages.contract.all': 'All',

  'pages.report.details.title': 'Report Coverage Time',
  'pages.report.details.country.title': 'Country Revenue Breakdown',
  'pages.report.details.platform.title': 'Platform Revenue Breakdown',
  'pages.report.details.profit.title': 'Song Revenue Breakdown',
  'pages.report.details.profit.album.title': 'Entity Revenue Breakdown',
  'pages.report.details.balance.title': 'Balance Changes',
  'pages.report.details.balance.change': 'Balance Change￥',
  'pages.report.details.balance.comment': 'Comment',
  'pages.report.details.balance.confirm': 'Confirm Balance Change',
  'pages.report.details.balance.confirm.content': 'Are you sure you want to add a balance change of ￥{balance}?',
  'pages.report.details.balance.cancel': 'Cancel Balance Change',
  'pages.report.details.balance.success': 'Balance change successful!',
  'pages.report.details.balance.error': 'Balance change failed',
  'pages.report.details.confirm.report': 'Confirm Report',
  'pages.report.details.confirm.report.content': 'Are you sure you want to confirm the report?',
  'pages.report.details.confirm.success': 'Confirmation successful, will be updated shortly',
  'pages.report.details.confirm.error': 'Confirmation failed',
  'pages.report.details.confirm.cancel': 'Cancel Report Confirmation',
  'pages.report.details.delete.report': 'Delete Report',
  'pages.report.details.delete.success': 'Delete Success',
  'pages.report.details.delete.report.content': 'Are you sure you want to delete report？',
  'pages.report.details.country': 'Country',
  'pages.report.details.platform': 'Platform',
  'pages.report.details.song.title': 'Song Title',
  'pages.report.details.song.isrc': 'ISRC',
  'pages.report.details.net.profit': 'Sales Amount',
  'pages.report.details.net.profit.artist': 'Artist Net Profit',
  'pages.report.details.play.count': 'Play/Usage Count',
  'pages.report.details.sale.count': 'Sale/Usage Quantity',

  'pages.report.details.add.balance': 'Add Balance Change',
  'pages.report.details.operation': 'Actions',
  'pages.report.details.edit': 'Edit',
  'pages.report.details.delete': 'Delete',
  'pages.report.details.confirm': 'Confirm',
  'pages.report.details.error': 'Failed',
  'pages.report.details.tooltip': 'Positive balances represent amounts payable to the artist, while negative balances represent costs to be deducted from the artist\'s account.',


  'pages.contract.report.page.title': 'Report Page',
  'pages.contract.report.page.download.excel': 'Download Excel Detailed Report',
  'pages.contract.report.page.download.pdf': 'Download PDF Settlement',
  'pages.contract.report.page.download.sales.list': 'Download Report Related Sales Records',
  'pages.contract.report.page.send.report': 'Send Report',
  'pages.contract.report.page.confirm.report': 'Confirm Report',
  'pages.contract.report.page.pay.report': 'Pay Report',
  'pages.contract.report.page.pay.contract': 'Pay Settlement Compilation',
  'pages.contract.report.page.refresh': 'Refresh',
  'pages.contract.report.page.unsent': 'Unsent',
  'pages.contract.report.page.sent': 'Sent',
  'pages.contract.report.page.read': 'Read',
  'pages.contract.report.page.confirmed': 'Confirmed',
  'pages.contract.report.page.paid': 'Paid',
  'pages.contract.report.page.unpaid': 'Unpaid',
  'pages.contract.report.page.view': 'View',
  'pages.contract.report.page.download': 'Download',
  'pages.contract.report.page.artist.short.id': 'Artist ID',
  'pages.contract.report.page.artist.name': 'Artist Name',
  'pages.contract.report.page.contract.start.date': 'Settlement Compilation Start Date',
  'pages.contract.report.page.contract.end.date': 'Settlement Compilation End Date',
  'pages.contract.report.page.contract.balance': 'Settlement Compilation Pending Payment￥',
  'pages.contract.report.page.contract.balance.tooltip': 'If positive, it represents the amount to be paid to the artist. If negative, it represents the prepaid amount. Reports must be confirmed by the artist to be included in the settlement compilation pending payment.',
  'pages.contract.report.page.report.status': 'Report Status',
  'pages.contract.report.page.net.profit': 'Sale Amount',
  'pages.contract.report.page.net.profit.artist': 'Artist Net Profit',
  'pages.contract.report.page.net.profit.artist.statement': 'Net profit after all deductions (e.g., production costs)',
  'pages.contract.report.page.generate.time': 'Generate Time',
  'pages.contract.report.page.is.paid': 'Is Paid',
  'pages.contract.report.page.action': 'Actions',
  'pages.contract.report.page.download.disabled': 'Exporting, will download automatically later',
  'pages.contract.report.page.download.success': 'Report download successful',
  'pages.contract.report.page.download.error': 'Report download failed',
  'pages.contract.report.page.send.success': 'Send successful',
  'pages.contract.report.page.send.error': 'Send failed',
  'pages.contract.report.page.confirm.success': 'Confirmation successful, will be updated shortly',
  'pages.contract.report.page.confirm.error': 'Confirmation failed',
  'pages.contract.report.page.pay.success': 'Payment successful, will be updated shortly',
  'pages.contract.report.page.pay.error': 'Payment failed',
  'pages.contract.report.page.cancel': 'Cancel',
  'pages.contract.report.page.per.page': 'Items per page',
  'pages.contract.report.page.per.page.option': 'Per page {size}',
  'pages.contract.report.page.artist.confirm': 'Confirm',
  'pages.contract.report.page.artist.delete': 'Delete',
  'pages.contract.report.page.artist.sent': 'Awaiting Confirmation',

  "pages.contract.artist.short.id": "Artist NO",
  "pages.contract.artist.name": "Artist Name",
  "pages.contract.contract.start.date": "Start Time",
  "pages.contract.contract.end.date": "End Time",

  'pages.contract.form.contractName': 'Settlement Compilation Name',
  'pages.contract.form.contractName.placeholder': 'Please enter the settlement compilation name',
  'pages.contract.form.artistName': 'Artist Name',
  'pages.contract.form.artistName.placeholder': 'Please enter the artist name',
  'pages.contract.form.artistEmail': 'Artist Email',
  'pages.contract.form.artistEmail.placeholder': 'Please enter the artist email',
  'pages.contract.form.contractStartTime': 'Settlement Compilation Start Date',
  'pages.contract.form.contractStartTime.placeholder': 'Please select the settlement compilation start date',
  'pages.contract.form.contractEndTime': 'Settlement Compilation End Date',
  'pages.contract.form.contractEndTime.placeholder': 'Please select the settlement compilation end date',
  'pages.contract.form.contractShareRate': 'Settlement Compilation Share Rate',
  'pages.contract.form.contractShareRate.placeholder': 'Please enter a decimal, e.g., 0.3 represents 30%',
  'pages.contract.form.contractStatus': 'Settlement Compilation Status',
  'pages.contract.form.contractStatus.placeholder': 'Please select the settlement compilation status',
  'pages.contract.form.contractComment': 'Remarks',
  'pages.contract.form.contractComment.placeholder': 'Please enter remarks',
  'pages.contract.form.contractPayType': 'Payment Method',
  'pages.contract.form.contractPayType.placeholder': 'Please select the payment method',
  'pages.contract.form.contractPayAccount': 'Payment Account',
  'pages.contract.form.contractPayAccount.placeholder': 'Please enter the payment account',
  'pages.contract.form.contractPayName': 'Payment Name',
  'pages.contract.form.contractPayName.placeholder': 'Please enter the payment name',
  'pages.contract.form.contractPayOpenBank': 'Bank Name',
  'pages.contract.form.contractPayOpenBank.placeholder': 'Please enter the bank name',
  'pages.contract.form.contractPrePay': 'Prepayment',
  'pages.contract.form.contractPrePay.placeholder': 'Please enter the prepayment, e.g., 200 represents a prepayment of 200 yuan',
  'pages.contract.form.contractBalance': 'Pending Payment Amount',
  'pages.contract.form.artifactList.title': 'List of Songs Related to the Settlement Compilation',
  'pages.contract.form.artifact.isrc': 'Song ISRC',
  'pages.contract.form.artifact.isrc.placeholder': 'Please enter the song ISRC',
  'pages.contract.form.artifact.songId': 'Song ID',
  'pages.contract.form.artifact.songId.placeholder': 'Please enter the song ID',
  'pages.contract.form.artifact.name': 'Song Name',
  'pages.contract.form.artifact.name.placeholder': 'Please enter the song name',
  'pages.contract.form.artifact.edit': 'Edit',
  'pages.contract.form.artifact.delete': 'Delete',
  'pages.contract.form.artifact.error.required': 'At least one related song must be added!',
  'pages.contract.form.artifact.error.nameEmpty': 'The song name cannot be empty!',
  'pages.contract.form.artifact.error.isrcOrIdRequired': 'At least one of the song ISRC and song ID must be filled!',

  'pages.contract.form.confirm.title': 'Confirm Settlement Compilation',
  'pages.contract.form.confirm.message': 'Please check the details of the settlement compilation：',

  'pages.contract.form.save.success': 'Settlement compilation saved successfully!',
  'pages.contract.form.save.draft.success': 'Settlement compilation draft saved successfully!！',
  'pages.contract.form.contractName.required': 'Please enter the settlement compilation name',
  'pages.contract.form.artistName.required': 'Please enter the artist name',
  'pages.contract.form.artistEmail.required': 'Please enter the artist email',
  'pages.contract.form.contractStartTime.required': 'Please select the settlement compilation start date',
  'pages.contract.form.contractEndTime.required': 'Please select the settlement compilation end date',
  'pages.contract.form.contractShareRate.required': 'Please enter the settlement compilation share rate',
  'pages.contract.form.contractStatus.required': 'Please select the settlement compilation status',
  'pages.contract.form.contractPayType.required': 'Please select the payment method',
  'pages.contract.form.contractPayAccount.required': 'Please enter the payment account',
  'pages.contract.form.contractPayName.required': 'Please enter the payment name',
  'pages.contract.form.contractPayOpenBank.required': 'Please enter the bank name',
  'pages.contract.form.contractPrePay.required': 'Please enter the prepayment',
  'pages.contract.form.contractBalance.required': 'Please enter the pending payment amount',
  'pages.contract.form.artifactList.noArtifacts': 'No related songs',
  'pages.contract.form.contractPayType.alipay': 'Alipay',
  'pages.contract.form.contractPayType.bank': 'Bank account',

  'pages.title.welcome': "Welcome Page",
  'pages.title.contractManage': "Online Settlement Compilation Management",
  'pages.title.contractList': "Online Settlement Compilation List",
  'pages.title.draft.contractList': "Online Settlement Compilation Draft List",
  'pages.title.contractListArtist': "Signed Settlement Compilation List",
  "pages.title.reportManage": "Report Manage",
  "pages.title.reportDetails": "Online Sales Report Details",
  "pages.title.reportDetailsArtist": "Royalty Statement Details",

  'pages.title.albumContractManage': "Album Contract Manage",
  'pages.title.albumContractDraftManage': "Album Contract Draft Manage",
  'pages.title.albumContractAdd': "Add Album Contract",
  'pages.title.albumReportManage': "Album Sales Report",



  "global.loading.text": "Loading..."


};
